import * as rive from "@rive-app/canvas";
import escape from "./helpers/escape.js";
import botContent from "./helpers/bot-content.json";

const button = document.querySelector(".demo-button");
const tplChatMsg = document.querySelector("template.template-chat-msg");
const chatList = document.querySelector(".demo-chat-list");
const chatLog = document.querySelector(".demo-chat-log");
const chatInput = document.querySelector(".demo-chat-input");


let riveInputThinking = null;
const r = new rive.Rive({
  src: "rive/chat_bot.riv",
  canvas: document.querySelector("canvas"),
  autoplay: true,
  stateMachines: "State Machine 1",
  fit: rive.Fit.cover,
  onLoad: (_) => {
    const inputs = r.stateMachineInputs("State Machine 1");
    riveInputThinking = inputs.find((i) => i.name === "thinking");
    riveInputThinking.value = false;
  },
  onStateChange: (event) => {
    console.log(event.data);
  },
});

const handleOutboundChat = () => {
  // create an element using the contents of the template
  const chat = tplChatMsg.content.cloneNode(true);
  const msg = chat.querySelector(".demo-chat-msg");
  chat
    .querySelector(".slds-chat-listitem")
    .classList.add("slds-chat-listitem_outbound");
  chat
    .querySelector(".slds-chat-message__text")
    .classList.add("slds-chat-message__text_outbound");
  if (chatInput.value !== "") msg.innerHTML = chatInput.value;
  chatInput.value = "";

  chat.querySelector(".demo-chat-timestamp").innerHTML =
    new Date().toLocaleTimeString([], { timeStyle: "short" });

  chat.querySelector(".demo-chat-author").innerHTML = "You";

  // prepend the new element to the .demo-checkbox-list
  chatList.append(chat);

  // animate scroll to bottom
  chatLog.scrollTop = chatLog.scrollHeight;

  setTimeout(handleInboundChat, 2222);
  riveInputThinking.value = true;
};

let curBotResponse = 0;
const handleInboundChat = () => {
  riveInputThinking.value = false;
  // create an element using the contents of the template
  const chat = tplChatMsg.content.cloneNode(true);
  const msg = chat.querySelector(".demo-chat-msg");
  chat
  .querySelector(".slds-chat-listitem")
  .classList.add("slds-chat-listitem_inbound");
  chat
  .querySelector(".slds-chat-message__text")
  .classList.add("slds-chat-message__text_inbound");
  msg.innerHTML = botContent[curBotResponse];
  curBotResponse + 1 < botContent.length && curBotResponse++;

  chat.querySelector(".demo-chat-timestamp").innerHTML =
  new Date().toLocaleTimeString([], { timeStyle: "short" });

  chat.querySelector(".demo-chat-author").innerHTML = "TDX Kinetics Bot";

  // prepend the new element to the .demo-checkbox-list
  chatList.append(chat);

  // animate scroll to bottom
  chatLog.scrollTop = chatLog.scrollHeight;
};

chatInput.addEventListener("keyup", (e) => {
  e.code === "Enter" && chatInput.value.trim() && handleOutboundChat();
});
// button.addEventListener("click", handleOutboundChat);
// add eventlistener for spacebar
document.addEventListener("keyup", (e) => {
  if (e.target === chatInput && e.code !== "Enter")
    riveInputThinking.value = false;
  e.target !== chatInput && e.code === "Space" && handleOutboundChat();
});

const canvas = document.querySelector("canvas");
canvas.addEventListener("mousemove", (e) => {
  e.stopPropagation();
});
document.body.addEventListener("mousemove", (e) => {
  e.stopPropagation();
  const new_e = new e.constructor(e.type, e);
  canvas.dispatchEvent(new_e);
});

const init = () => {
  // get chatLog initial height
  chatLog.style.setProperty(
    "--demo-chat-log-slug-height",
    `${chatLog.clientHeight}px`
  );
};

init();
escape("menu.html");